/**
 * Le NOM HUMAIN d'une capacité déléguable. Ce fichier nomme, il n'autorise rien.
 *
 * ⚠️ AJOUTER UNE ENTRÉE ICI N'OUVRE AUCUN DROIT, et n'en propose même pas un de plus à
 * l'écran. Ce que l'administrateur peut ouvrir est décidé par `DELEGABLES`
 * (`backend/app/core/authz.py`), plafonné par le rôle, et ARRIVE PAR L'API dans le
 * champ `delegables` de `GET /admin/delegations`. L'écran itère cette liste-là ; ce
 * dictionnaire n'est consulté qu'ensuite, pour remplacer un code par une phrase.
 *
 * Une capacité sans entrée ici s'affiche donc sous son code technique — moins joli,
 * jamais faux. C'est le repli voulu : mieux vaut un libellé aride qu'une capacité
 * absente de l'écran parce que personne n'a pensé à la nommer.
 *
 * `test_privileges_dans_les_utilisateurs.py` vérifie que chaque clé de ce fichier est
 * bien déléguable côté serveur : un code inventé ici serait un libellé orphelin, donc
 * une promesse d'écran que rien ne tient.
 */
export const LIBELLES_CAPACITES = {
  'clients:agregateur': {
    titre: "Changer l'agrégateur d'un client",
    detail: "Depuis la fiche client comme depuis la ligne du tableau. Fermé, les deux "
      + 'répondent « accès refusé » — y compris en tapant l’adresse.',
  },
};

/** Le nom humain, ou le code lui-même quand personne ne l'a encore nommé. */
export const titreCapacite = (code) => LIBELLES_CAPACITES[code]?.titre || code;

/** La précision sous le titre, vide quand il n'y en a pas. */
export const detailCapacite = (code) => LIBELLES_CAPACITES[code]?.detail || '';

/** Le nom que David donne au rôle, à défaut la clé technique (voir ROLE_CONFIG). */
export const LIBELLES_ROLES = {
  admin: 'Admin',
  commercial: 'Gestionnaire',
  installateur: 'Installateur',
  poseur: 'Poseur',
  distributeur: 'Distributeur',
};
